export default "__VITE_ASSET__DFgSV$5G__"